import { Component, ViewChild } from '@angular/core';
import { Platform, NavController, NavParams, ViewController, Events, LoadingController } from 'ionic-angular';
import { EventCodes } from '../core/codes';
import { UserData } from '../providers/user-data';
import { FeedData } from '../providers/feed-data';
import { Utils } from '../providers/utils';
import _ from 'lodash';

@Component({
	templateUrl: 'modal-comment-submit.html'
})

export class ModalCommentSubmit {
	public commentData: any;
	public currentUser: any;
	public post: any;
	public loader: any;
	@ViewChild('commentInput') commentInput: any;

	constructor(
		public nav: NavController,
		public platform: Platform,
    	public params: NavParams,
    	public viewCtrl: ViewController,
        public loadingCtrl: LoadingController,
        private userData: UserData,
    	private feedData: FeedData,
    	private events: Events
    ) {	
    	this.initData();
    }

	ionViewDidEnter() {
		this.commentInput.nativeElement.focus();
	}

	public dismiss() {
		this.viewCtrl.dismiss();
	}

	public initData(){
		var self = this;
        this.currentUser = this.params.get("user");
        this.post = this.params.get("post");

		this.commentData = {
            authorName: this.currentUser? this.currentUser.displayName: "",
            authorPic: this.currentUser? this.currentUser.photoURL: "",
            uid: this.currentUser? this.currentUser.uid : 0,
            text: ''
        };
        
        if(this.post.value.commentCount > 0){
            this.feedData.getPostComments(this.post.key).subscribe(comments => {
                self.post.comments = comments;
            });
        }
	}
  
  	public submitComment(){
  		var self = this;
  		self.showLoading()
		this.feedData.addPostComments(self.post, self.commentData).subscribe(newPost =>{
			//console.log(newPost);
			self.hideLoading();
			self.loader.onDidDismiss(()=>{
				self.events.publish(EventCodes.POST_SUBMITTED);
			});
		});
  	}

  	public showLoading(){
        this.loader = this.loadingCtrl.create();
        this.loader.present();
      
    }

    public hideLoading(){
        this.loader.dismiss();
    }

	public getNameInitials(name){
        return Utils.getFirstInitials(name);
    }

    public formatNum(num){
        if(!num){return "";}
        return Utils.formatNumberToString(num);
    }

    public getTimeSince(unixTime){
        return Utils.timeSince(unixTime);
    }

    public myLike(post){
        let self = this;
        if(!self.currentUser){return false;}
        return _.find(post.likes, function(likeUser){
            let lUser:any = likeUser;
            return lUser.value.uid == self.currentUser.uid;
        });
    }
}	



// WEBPACK FOOTER //
// ./src/components/modal-comment-submit.ts